var map = {
	"./p-address-input.vue": "./src/components/p-address-input.vue",
	"./p-address.vue": "./src/components/p-address.vue",
	"./p-advanced-select.vue": "./src/components/p-advanced-select.vue",
	"./p-box-widget.vue": "./src/components/p-box-widget.vue",
	"./p-button.vue": "./src/components/p-button.vue",
	"./p-card.vue": "./src/components/p-card.vue",
	"./p-checkbox-group.vue": "./src/components/p-checkbox-group.vue",
	"./p-checkbox.vue": "./src/components/p-checkbox.vue",
	"./p-color-picker.vue": "./src/components/p-color-picker.vue",
	"./p-date-range-widget.vue": "./src/components/p-date-range-widget.vue",
	"./p-date-range.vue": "./src/components/p-date-range.vue",
	"./p-datepicker.vue": "./src/components/p-datepicker.vue",
	"./p-draggable-tree.vue": "./src/components/p-draggable-tree.vue",
	"./p-draggable.vue": "./src/components/p-draggable.vue",
	"./p-feature-flag.vue": "./src/components/p-feature-flag.vue",
	"./p-filter-select.vue": "./src/components/p-filter-select.vue",
	"./p-form.vue": "./src/components/p-form.vue",
	"./p-image.vue": "./src/components/p-image.vue",
	"./p-input.vue": "./src/components/p-input.vue",
	"./p-modal-date-range.vue": "./src/components/p-modal-date-range.vue",
	"./p-modal.vue": "./src/components/p-modal.vue",
	"./p-multiselect.vue": "./src/components/p-multiselect.vue",
	"./p-number.vue": "./src/components/p-number.vue",
	"./p-phone-number.vue": "./src/components/p-phone-number.vue",
	"./p-search-screen.vue": "./src/components/p-search-screen.vue",
	"./p-search-table.vue": "./src/components/p-search-table.vue",
	"./p-secure.vue": "./src/components/p-secure.vue",
	"./p-select.vue": "./src/components/p-select.vue",
	"./p-slider.vue": "./src/components/p-slider.vue",
	"./p-table.vue": "./src/components/p-table.vue",
	"./p-text-area.vue": "./src/components/p-text-area.vue",
	"./p-timepicker.vue": "./src/components/p-timepicker.vue",
	"./p-tree.vue": "./src/components/p-tree.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components sync p-[\\w.-]+\\.(vue%7Cjs)$";